import { Badge } from "primereact/badge";
import { Checkbox } from "primereact/checkbox";

export const columns=[    
       { 
        field: "roleId", 
        header: "Role",
        accessor: (row,handleCellClick) => (
            <>
              <div  onClick={()=>handleCellClick(row,"roleId")}  className="">          
                <p className="w-[6rem] cursor-pointer text-blue-600 hover:text-blue-800" >
                {row?.roleId?.name||""}
                </p>
              </div>
            </>
          ),
       },      
       { 
        field: "component", 
        header: "Component",
        accessor: (row,handleCellClick) => (
            <>
              <div  onClick={()=>handleCellClick(row,"component")}  className="">          
                <p className="w-[6rem]" >
                {row?.component?.name||""}
                </p>
              </div>
            </>
          ),
       },      
       { 
        field: "componentType", 
        header: "Component Type",
        accessor: (row,handleCellClick) => (
            <>
              <div  onClick={()=>handleCellClick(row,"componentType")}  className="">          
                <p className="w-[6rem]" >
                {row?.componentType?.name||""}
                </p>
              </div>
            </>
          ),
       },
     
       { 
        field: "permissions", 
        header: "permissions",
        accessor: (row,handleCellClick) =>{ 
          
          return(
            <>
              <div    className="justify-between">  
                  <form className="w-[15rem] flex flex-wrap justify-between gap-2">
                        
                        {row?.permissions && row?.permissions?.length && row?.permissions?.map((item,i)=><div key={i} >
                          <div className="flex gap-2 w-30">
                           <label htmlFor={`${item?.permissionName}-${i}`} className="w-[3rem]"> {item?.permissionName}</label>
                      
                           <Checkbox id={`${item?.permissionName}-${i}`} value={item?.permissionName} onClick={()=>handleCellClick({id:row._id,permissions:row?.permissions.filter((p)=>p._id!==item._id)},"permissions")} checked={true}></Checkbox>
                          </div>
                        </div>)}
                  </form>
              </div>
            </>
          ) 
        }
       },
       { 
        field: "active", 
        header: "Active",
        accessor: (row,handleCellClick) => (
            <>
              <div  onClick={()=>handleCellClick(row,"active")}  className="">          
                <p className="w-[6rem]">                    
                 <Badge
                  className="w-[6rem]"
                  severity={
                    row?.active === true
                      ? "success"
                      : "danger"
                  }
                  value={row?.active?"Enabled":"Disabled"}
                ></Badge>          
                </p>
              </div>
            </>
          ), 
       },
]

export const searchBy = {
  filterType: "Sort By",
  inputName: "search_by",
  options: [
    {
      name: "Descending ",
      code: "desc",
    },
    {
      name: "Ascending",
      code: "asc",
    },
  ],
};